import React from "react";
// @material-ui/core components
import { title } from "assets/jss/material-kit-react.js";
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import Carousel from "react-slick";


import reviewImg1 from "assets/img/faces/andrea.jpg";
import reviewImg2 from "assets/img/faces/dayna.jpg";
import reviewImg3 from "assets/img/faces/deirde.jpg";
import reviewImg4 from "assets/img/faces/jennifer.jpg";
import reviewImg5 from "assets/img/faces/marielle.jpg";
import reviewImg6 from "assets/img/faces/mickelle.jpg";
import Testimonial from "components/Testimonial/Testimonial.js";


export default function TestimonialSection() {
    const classes = makeStyles({
    section: {
        padding: "70px 0",
        textAlign: "center"
      },
      title: {
        ...title,
        marginBottom: "1rem",
        marginTop: "30px",
        minHeight: "32px",
        textDecoration: "none"
      }
    })()
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };
  const reviews = [
      {
        img: reviewImg2,
        name: 'Dayna H.',
        description: "I loved my experience here. I apologize for not having a name to share, but the woman who helped me was INCREDIBLE. First, I called to check and see if walk-ins were okay. The call went to voicemail, but as soon as I hung up, she returned my call. \nThe prices are AMAZING...I did my brows, lip, and chin for about $16. She checked with me multiple times to make sure I wasn't in pain. Threading is always a little uncomfortable, but she is so quick that it really isn't bad--promise!"
      },
      {
        img: reviewImg3,
        name: 'Deirde L.',
        description: 'Love this studio. The lady is always so nice. The studio is very clean and there is hardly ever a wait. A nice little spot to come to!'
      },
      {
          img: reviewImg6,
          name: 'Mickelle D.',
          description: "I had a great experience here! Shallu and Sarah were so warm and welcoming. The place is very clean. I got my eyebrows threaded and tinted, my lip threaded and a chocolate Brazilian. While everything was fantastic, the chocolate Brazilian was the best! I felt no pain and that's amazing :-) and the prices are extremely reasonable.  I came in with a Groupon for a Brazilian wax and they gave me a punch card for 7 more waxes at the Groupon price!Don't hesitate to try this place out."
      },
      {
        img: reviewImg5,
        name: 'Marielle G.',
        description: 'Looove it here! Shalu is fantastic, attentive, and kind. The location is convenient and clean. Highly recommend this place!'
      },
      {
        img: reviewImg1,
        name: 'Andrea P.',
        description: "I just stopped into Lili's and had a great experience. Niketa, who did my waxes and my eyebrow threading, was friendly and very personable. The place is clean and very well-priced - they're having amazing grand opening deals right now because they just opened last week. I didn't have a threading/waxing place before in the neighborhood, so I'm glad this place opened."
      },
      {
        img: reviewImg4,
        name: 'Jennifer Y.',
        description: "Stopped by here for a quick walk-in one evening, and both ladies were very nice. The space is clean, tidy and you can tell it's new. Their prices are great since they're promoting their opening, and the threading was exactly how I wanted. I explained to my threader what I wanted and she did it flawlessly!\nA good place to have in my back pocket, the prices were very reasonable and I also did some light waxing which was quick and painless as well. Very much appreciated the cleanliness and professional behavior."
      }
  ]
  function createTestimonial() {
      const items = []
    for(var i = 0; i < reviews.length; i++) {
        items.push(<Testimonial img={reviews[i].img} key={i} alt={i} name={reviews[i].name} description={reviews[i].description}/>)
    }
    return items
  }

  return (
    <div className={classes.section}>
      <h2 className={classes.title}>Testimonials</h2>
      <div>
        <Carousel {...settings}>
            {createTestimonial()}
        </Carousel>
      </div>
    </div>
  );
}
